<template>
  <div id="app">
    <!-- <router-view :style="`-webkit-zoom:${ww};-o-zoom:${ww};-ms-zoom:${ww};-moz-transform:scale(${ww});-moz-transform-origin:center;zoom:${ww};`"/> -->
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            ww: 0
        }
    },
    watch:{
        $route(){
            // console.log(to)
            let windowWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
            console.log(windowWidth)
            this.ww = windowWidth / 1920
            console.log(this.ww)
            window.onresize = () => {
                // console.log('aaaaaaaaaaaaaaa')
                return (() => {
                    let windowWidth1 = document.documentElement.offsetWidth || document.body.offsetWidth;
                    this.ww = windowWidth1 / 1920
                    // console.log(windowWidth1)
                })()
            }
        }
    },
    mounted() {
        // let windowWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
        // this.ww = windowWidth / 1920
        // window.onresize = () => {
        //     return (() => {
        //         let windowWidth1 = document.documentElement.offsetWidth || document.body.offsetWidth;
        //         this.ww = windowWidth1 / 1920
        //     })()
        // }
    }
}
</script>

<style>
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
#app {
  font-family: "Open Sans";
  font-size: 16px;
}
body{
  font-family: "Open Sans" !important;
}
.ivu-checkbox-checked .ivu-checkbox-inner,
.ivu-checkbox-indeterminate .ivu-checkbox-inner {
  border-color: #f0b893 !important;
  background-color: #f0b893 !important;
}

.ivu-input:hover,
.ivu-input:focus{
  border-color: #f0b893 !important;
  outline: none !important;
  box-shadow: none !important;
}

.ivu-input{
  outline: none;
}

.ivu-date-picker-cells-focused em{
  box-shadow: 0 0 0 1px #f0b893 inset !important;
}

.ivu-date-picker-cells-cell-today em:after{
  background: #f0b893 !important;
}
.ivu-date-picker-cells-cell-selected em, .ivu-date-picker-cells-cell-selected:hover em{
  background: #f0b893 !important;
}
.ivu-date-picker-cells-cell:hover em{
  background: #f0d4c1 !important;
}
.ivu-date-picker-focused input,
.ivu-select-selection-focused, 
.ivu-select-selection:hover,
.ivu-page-options-elevator input:focus{
  border-color: #f0b893 !important;
  outline: none !important;
  box-shadow: none !important;
}
.ivu-date-picker-header-label:hover{
  color: #f0b893 !important;
}
.ivu-picker-panel-icon-btn:hover,
.ivu-page-item-active a, 
.ivu-page-item-active:hover a,
.ivu-page-item:hover a,
.ivu-page-item-jump-next a,
.ivu-page-next:hover a, 
.ivu-page-prev:hover a,
.ivu-select-item-selected, 
.ivu-select-item-selected:hover{
  color: #f0b893 !important;
}
.ivu-page-item-active,
.ivu-page-item:hover,
.ivu-page-next:hover, 
.ivu-page-prev:hover,
.ivu-select-selection-focused, 
.ivu-select-selection:hover,
.ivu-page-options-elevator input:hover {
  border-color: #f0b893 !important;
}
/* .ivu-btn-warning{
  background-color: #f0b893 !important;
  border-color: #f0b893 !important;
} */
.ivu-table th{
  background-color: #fce2cb !important;
}

/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
/* .gm-scrollbar-container .gm-scroll-view{
  overflow: hidden !important;
} */
.gm-scrollbar{
  right: 0px !important;
  bottom: 0px !important;
}
.gm-scrollbar.-horizontal{
  width: calc(100% - 10px);
  height: 8px !important;
  background-color: #ffffff;
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  border-radius: 4px;
}
.gm-scrollbar.-vertical{
  width: 8px !important;
  height: calc(100% - 10px);
  background-color: #ffffff;
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  border-radius: 4px;
}
/*定义滚动条的轨道，内阴影及圆角*/
.gm-scrollbar .thumb{
    width: 10px;
    height: 10px;
    border-radius: 4px;
    box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #bab6b7;
}
/*定义滑块，内阴影及圆角*/
/* ::-webkit-scrollbar-thumb{
    width: 10px;
    height: 10px;
    border-radius: 4px;
    box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #bab6b7;
}
::-webkit-scrollbar-button:end:increment{
  width: 10px;
  height: 40px;
  background: url('./assets/img/scrollbar-down.png') no-repeat;
  background-size: 100%;
}
::-webkit-scrollbar-button:start:decrement{
  width: 10px;
  height: 40px;
  background: url('./assets/img/scrollbar-up.png') no-repeat;
  background-size: 100%;
} */
.ivu-modal-header{
  padding: 0 !important;
  border-bottom: none !important;
}
.ivu-modal-footer{
  text-align: center !important;
}
.ivu-modal-body{
  padding: 0 !important;
}
.ivu-modal-footer{
  padding: 0 0 22px 0 !important;
  border-top: none !important;
}
</style>
<style lang="less">
.mine-from1 {
    .ivu-select-single .ivu-select-selection .ivu-select-placeholder, 
    .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        padding-left: 0 !important;
    }
}
.automatic-table .row-class td{
    background: #a59898 !important;
    // color: #fff !important;
}
.ivu-tree-title:hover,
.ivu-tree-title-selected{
    background: none !important;
}
.ivu-tree-title{
    cursor: default !important;
}
.custom-modal{
    .ivu-modal-footer{
      background: #f2f5fa !important;
    }
    .ivu-modal-content{
      overflow: hidden !important;
    }
}
.custom-modal1{
    .ivu-modal-footer{
      background: #fff !important;
    }
    .ivu-modal-content{
      overflow: hidden !important;
    }
}
.case-information1{
  .ivu-input {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
}
.management-table-select{
  a {
    color: #f38120;
  }
  a:hover {
    color: #f38120;
  }
}
.child-main-switch{
  .ivu-switch-checked{
    border-color: #f48221;
    background-color: #f48221;
  }
}
.login-user{
  .ivu-input{
    height: 53px !important;
    border: none !important;
    border-right: 1px solid #dcdee2 !important;
    border-top: 1px solid #dcdee2 !important;
    border-bottom: 1px solid #dcdee2 !important;
  }
}
.login-user{
  .ivu-input-group-append, .ivu-input-group-prepend{
    border: none !important;
    border-left: 1px solid #dcdee2 !important;
    border-top: 1px solid #dcdee2 !important;
    border-bottom: 1px solid #dcdee2 !important;
    background-color: #fff !important;
    height: 53px !important;
  }
}
.custom-modal2{
  .ivu-modal-body{
    background: #f2f5fa !important;
  }
    .ivu-modal-footer{
      background: #f2f5fa !important;
    }
    .ivu-modal-content{
      overflow: hidden;
    }
}
.custom-modal5{
    .ivu-modal-footer{
        background: #fff !important;
    }
    .ivu-modal-footer{
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }
}
.login-user1{
  .ivu-input{
    height: 53px !important;
  }
}
.ivu-tree ul{
    font-size: 16px !important;
    color: #666 !important;
  }
.automatic-tree{
  .ivu-icon-ios-arrow-forward:before{
    content: "" !important;
    display: block;
    width: 6px;
    height: 12px;
    background: url('../src/assets/img/tree.png') no-repeat;
    background-size: 100%;
  }
  .ivu-checkbox{
    width: 18px;
    height: 18px;
    background: url('./assets/img/treeckx1.png') no-repeat;
    background-size: 100%;
    *{
      display: none;
    }
  }
  .ivu-checkbox-indeterminate{
    background: url('./assets/img/treeckx.png') no-repeat !important;
    background-size: 100% !important;
  }
  .ivu-checkbox-checked{
    background: url('./assets/img/treeckx2.png') no-repeat !important;
    background-size: 100% !important;
  }
}
.ivu-icon-ios-calendar-outline::before{
  content: "" !important;
}
.ivu-icon-ios-calendar-outline{
  display: block;
  width: 18px;
  height: 18px;
  background: url('../src/assets/img/date.png') no-repeat !important;
  background-size: 100% !important;
  margin: 7px auto;
}

.ivu-input-suffix{
  background: #aaa9a9 !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ivu-input-suffix:hover{
  background: rgba(245,135,46,.10) !important;
  .ivu-icon-ios-calendar-outline{
  background: url('../src/assets/img/date1.png') no-repeat !important;
  background-size: 100% !important;
}
}
.el-scrollbar__wrap{
    height: calc(100% + 25px) !important;
    margin-right: -23px !important;
}
.automatic-table{
  .ivu-table-header thead tr th{
    text-align: center;
    font-size: 20px;
    color: #4a4b4c;
  }
  .ivu-table td{
    text-align: center;
    font-size: 18px;
    color: #4a4b4c;
  }
  .ivu-table-cell{
    word-break: normal !important;
  }
}
.ivu-btn-warning{
  background-color: #f48221 !important;
  border-color: #f48221 !important;
  font-size: 18px !important;
}
.ivu-table-row-hover td {
    background-color: #f3f3f3!important;
  }
th{
  font-weight: normal;
}
.ivu-modal-mask{
  background-color: rgba(102,102,102,.25) !important;
}
.ivu-icon-ios-close:before{
  content: "" !important;
  display: block;
  width: 32px;
  height: 32px;
  background: url('../src/assets/img/modal-close.png') no-repeat;
  background-size: 100%;
}
.ivu-modal-close{
  right: 40px !important;
  top: 20px !important;
}
.ivu-select-arrow{
  right: -1px !important;
  display: block;
  width: 28px;
  height: 31px;
  background: url('../src/assets/img/select.png') no-repeat;
  background-size: 100%;
  line-height: 32px;
}
.ivu-select-arrow:hover{
  right: -1px !important;
  display: block;
  width: 28px;
  height: 31px;
  background: url('../src/assets/img/select1.png') no-repeat;
  background-size: 100%;
  line-height: 32px;
}
.ivu-select-visible .ivu-select-arrow{
  transform: translateY(-50%) rotate(0deg) !important;
}
.ivu-icon-ios-arrow-down:before{
  content: "" !important;
}
.custom-modal-details{
  .ivu-modal-body{
    background: #f2f5fa !important;
  }
    .ivu-modal-footer{
      background: #f2f5fa !important;
    }
    .ivu-modal-content{
      overflow: hidden;
    }
//   .ivu-modal{
//     position: absolute !important;
//     margin: auto !important;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     height: 820px;
//     // display: flex;
//     // align-items: center;
//     // justify-content: center;
//   }
}
.custom-modal-case{
//   .ivu-modal{
//     position: absolute !important;
//     margin: auto !important;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     height: 820px;
//   }
  .ivu-modal-footer{
    background: #f2f5fa !important;
  }
  .ivu-modal-content{
    overflow: hidden !important;
  }
}
.ivu-form .ivu-form-item-label{
  font-size: 20px!important;
  color: #4A4B4C!important;
}
.ivu-table-wrapper{
  overflow: unset !important;
}
.ivu-dropdown-menu{
  .ivu-dropdown-item{
    font-size: 18px !important;
    text-align: left;
  }
}
.ivu-dropdown-item:hover{
  color: #fff !important;
  background-color: #F48221 !important;
}
.ivu-btn-error{
  background-color: #F0502F !important;
  border-color: #F0502F !important;
  font-size: 18px !important;
}
.ivu-select{
  .ivu-select-dropdown{
    max-height: 100px !important;
  }
}
// .form-hang{
//     // .ivu-select-dropdown{
//     //     top: 34px !important
//     // }
// }
.notic-table{
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  .ivu-table-overflowX{
    overflow-x: hidden;
  }
  .ivu-table-header thead tr th{
    text-align: center;
    font-size: 20px;
    color: #4a4b4c;
  }
  .ivu-table td{
    text-align: center;
    font-size: 18px;
    color: #4a4b4c;
  }
  .ivu-table-cell{
    word-break: normal !important;
  }
}
.ivu-date-picker-cells-cell{
    width: 44px!important;
    height: 44px!important;
    em{
      width: 40px!important;
      height: 40px!important;
      line-height: 40px!important;
    }
}
.ivu-date-picker-cells-header span{
  line-height: 40px!important;
  width: 40px!important;
  height: 40px!important;
  color: #F48221 !important;
}
.ivu-date-picker-cells{
      width: 308px !important;
}
.el-select{
    height: 32px !important;
}
</style>